import styled, { css } from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h1`
  margin-bottom: 1.5rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.dark_background};
  font-size: 1rem;
  font-weight: 500;
  margin: 2.5rem 0;
`;

export const WrapperChoices = styled.div`
  ${({ theme }) => css`
    margin: 0 auto;
    margin-bottom: 2.5rem;

    display: flex;
    align-items: center;
    gap: 1.93rem;

    @media (max-width: ${theme.breakpoints.medium}) {
      flex-direction: column;
      align-items: center;
      gap: 0.5rem;
    }
  `}
`;

export const WrapperButtons = styled.div`
  display: flex;
  justify-content: center;
`;
